/**
 * @file FooterColumnsToolbar.tsx
 * @description Кнопки «+ Добавить колонку» и «+ Категории каталога» в
 * «Меню → Подвал» (phase19.16, приёмка Р2а; SB113; uiux-footer-columns §4.6,
 * §4.7, §5): неактивны при 3 из 3 с текстом лимита; на узкой колонке
 * (телефон, панель конструктора) — липкая полоса снизу «[+ Колонка] (N из 3)».
 * Полоса — одна строка (QA: пояснение в две строки закрывало карточки на
 * 1280): при лимите короткая пометка, полный текст — во всплывающей подсказке.
 */

import { Plus } from "lucide-react";

import { Button } from "../../ui/button";
import { cn } from "@/lib/utils";

interface Props {
  count: number;
  limit: number;
  /** Есть пустые колонки — подсказать удалить пустую. */
  hasEmpty: boolean;
  /** Колонки категорий каталога ещё нет — можно добавить. */
  canAddAuto: boolean;
  busy: boolean;
  narrow: boolean;
  onAdd: (kind: "GROUP" | "CATALOG_CATEGORIES") => void;
}

export function FooterColumnsToolbar({ count, limit, hasEmpty, canAddAuto, busy, narrow, onAdd }: Props) {
  const full = count >= limit;
  const why = `Колонок меню — не больше ${limit}: в четыре колонки подвал на ПК ещё читается, в пять — уже нет. Объедините колонки или удалите лишнюю.${hasEmpty ? " Удалите пустую, чтобы добавить другую." : ""}`;
  return (
    <div
      className={cn(
        "flex items-center",
        narrow && "sticky bottom-0 z-10 -mx-1 bg-surface-lowest px-1 py-2 [box-shadow:0_-1px_0_var(--border)]",
      )}
    >
      <div className="flex flex-wrap items-center gap-2">
        <Button variant="outline" disabled={full || busy} onClick={() => onAdd("GROUP")}>
          <Plus aria-hidden />
          {narrow ? "Колонка" : "Добавить колонку"}
        </Button>
        {canAddAuto ? (
          <Button variant="ghost" disabled={full || busy} onClick={() => onAdd("CATALOG_CATEGORIES")}>
            <Plus aria-hidden />
            Категории каталога
          </Button>
        ) : null}
        <span className="type-caption text-on-surface-variant tabular-nums" title={full ? why : undefined} aria-label={full ? `${count} из ${limit}. ${why}` : undefined}>
          ({count} из {limit}){full ? (hasEmpty ? " · больше нельзя, удалите пустую" : " · больше нельзя") : ""}
        </span>
      </div>
    </div>
  );
}
